module.exports = __webpack_public_path__ + "static/media/README.458cf8d1.md";